import { render, staticRenderFns } from "./CommunityGroupFormModal.vue?vue&type=template&id=2ec3f6e8&scoped=true&"
import script from "./CommunityGroupFormModal.vue?vue&type=script&lang=ts&"
export * from "./CommunityGroupFormModal.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityGroupFormModal.vue?vue&type=style&index=0&id=2ec3f6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec3f6e8",
  null
  
)

export default component.exports